import { SectionList } from "../components/sections";
import React, { Fragment } from "react";
export const AbuDhabi = () => (
  <Fragment>
    <SectionList place="Abu Dhabi"></SectionList>
  </Fragment>
);
